module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921091151_T.3f2b7209.jpg";